import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export default function SignupPage() {
  const navigate = useNavigate();
  const { setUser, setTokens, setError, error } = useAuthStore();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [nickname, setNickname] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password !== passwordConfirm) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    if (password.length < 8) {
      setError('비밀번호는 8자 이상이어야 합니다.');
      return;
    }

    if (nickname.length < 2 || nickname.length > 20) {
      setError('닉네임은 2-20자 사이여야 합니다.');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      // TODO: API 호출로 교체
      // const response = await authApi.signup({ email, password, nickname });
      
      // 임시 mock
      await new Promise((resolve) => setTimeout(resolve, 1000));
      
      // Mock 응답
      setUser({
        userId: 'user_' + Date.now(),
        email,
        nickname,
      });
      setTokens('mock_access_token', 'mock_refresh_token');
      
      navigate('/lobby', { replace: true });
    } catch (err) {
      setError('회원가입에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="text-xl font-semibold text-center mb-6">회원가입</h2>

      {error && (
        <div className="p-3 bg-red-500/20 border border-red-500/50 rounded-lg text-red-300 text-sm">
          {error}
        </div>
      )}

      <div>
        <label htmlFor="email" className="block text-sm text-slate-300 mb-1">
          이메일
        </label>
        <input
          id="email"
          type="email"
          className="input"
          placeholder="example@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />
      </div>

      <div>
        <label htmlFor="nickname" className="block text-sm text-slate-300 mb-1">
          닉네임
        </label>
        <input
          id="nickname"
          type="text"
          className="input"
          placeholder="2-20자"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          required
          minLength={2}
          maxLength={20}
        />
      </div>

      <div>
        <label htmlFor="password" className="block text-sm text-slate-300 mb-1">
          비밀번호
        </label>
        <input
          id="password"
          type="password"
          className="input"
          placeholder="8자 이상"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={8}
          autoComplete="new-password"
        />
      </div>

      <div>
        <label htmlFor="passwordConfirm" className="block text-sm text-slate-300 mb-1">
          비밀번호 확인
        </label>
        <input
          id="passwordConfirm"
          type="password"
          className="input"
          placeholder="비밀번호 재입력"
          value={passwordConfirm}
          onChange={(e) => setPasswordConfirm(e.target.value)}
          required
          autoComplete="new-password"
        />
      </div>

      <button
        type="submit"
        className="btn-primary w-full py-3"
        disabled={isLoading}
      >
        {isLoading ? '가입 중...' : '회원가입'}
      </button>

      <p className="text-center text-slate-400 text-sm">
        이미 계정이 있으신가요?{' '}
        <Link to="/login" className="text-primary-400 hover:underline">
          로그인
        </Link>
      </p>
    </form>
  );
}
